import Cookie from "js-cookie";
import SSRCookie from "cookie";
import {
  AUTH_CRED,
  PERMISSIONS,
  STAFF,
  STORE_OWNER,
  SUPER_ADMIN,
  TOKEN,
  ADMIN,
  MARKETER,
  SALER,
  SHIPMENT,
  PARTNERSHIP_SUPPORTER
} from "./constants";
import { ROUTES } from "./routes";

export const adminAndOwnerReportOnly = [SUPER_ADMIN, ADMIN, STORE_OWNER];
export const allowedRoles = [SUPER_ADMIN, ADMIN, STORE_OWNER, MARKETER, SALER, PARTNERSHIP_SUPPORTER, SHIPMENT];
export const adminAndOwnerOnly = [SUPER_ADMIN, ADMIN, STORE_OWNER];
export const adminOwnerAndStaffOnly = [SUPER_ADMIN, STORE_OWNER, STAFF];
export const adminOnly = [SUPER_ADMIN];
export const ownerOnly = [STORE_OWNER];
export const adminSalerAndMaketer = [SUPER_ADMIN, ADMIN, MARKETER, SALER];
export const adminSalerAndShipment = [SUPER_ADMIN, ADMIN, MARKETER, SHIPMENT];
export const adminSalerShipmentAndOwner = [SUPER_ADMIN, ADMIN, MARKETER, SHIPMENT, STORE_OWNER];
export const adminAndMaketer = [SUPER_ADMIN, ADMIN, MARKETER];
export const superAdminAndAdmin = [SUPER_ADMIN, ADMIN];
export const superAdminAndAdminAndOwner = [SUPER_ADMIN, ADMIN, STORE_OWNER];
export const acceptedProductRoles = [SUPER_ADMIN, ADMIN, STORE_OWNER, PARTNERSHIP_SUPPORTER];
export const acceptedOrderRoles = [SUPER_ADMIN, ADMIN, STORE_OWNER, SALER];
export const acceptedDirectionAndTaxRoles = [SUPER_ADMIN, ADMIN, SALER];
export const acceptedUserRoles = [SUPER_ADMIN, ADMIN, SALER, SHIPMENT];
export const acceptedShopRoles = [SUPER_ADMIN, ADMIN, MARKETER, PARTNERSHIP_SUPPORTER];
export const acceptedPromotionRoles = [SUPER_ADMIN, ADMIN, MARKETER];
export const acceptedClaimRoles = [SUPER_ADMIN, ADMIN, STORE_OWNER, SALER, PARTNERSHIP_SUPPORTER, SHIPMENT];
export const acceptedCompanyRoles = [SUPER_ADMIN, ADMIN];
export const acceptedShopOwnerRoles = [SUPER_ADMIN, ADMIN, MARKETER, PARTNERSHIP_SUPPORTER, STORE_OWNER];
export const acceptedEditShopRoles = [STORE_OWNER];
export const acceptedAllShopRoles = [SUPER_ADMIN, ADMIN, SALER];

export const mathRouterWithPath: any = {
  [SUPER_ADMIN]: ROUTES.DASHBOARD,
  [ADMIN]: ROUTES.DASHBOARD,
  [STORE_OWNER]: ROUTES.PRODUCTS,
  [MARKETER]: ROUTES.SHOPS,
  [SALER]: ROUTES.USERS,
  [PARTNERSHIP_SUPPORTER]: ROUTES.PRODUCTS,
  [SHIPMENT]: ROUTES.USERS
}

export function setAuthCredentials(token: string, permissions: any) {
  Cookie.set(AUTH_CRED, JSON.stringify({ token, permissions }));
}

export function getAuthCredentials(context?: any): {
  token: string | null;
  permissions: string[] | null;
} {
  let authCred;
  if (context) {
    authCred = parseSSRCookie(context)[AUTH_CRED];
  } else {
    authCred = Cookie.get(AUTH_CRED);
  }
  if (authCred) {
    return JSON.parse(authCred);
  }
  return { token: null, permissions: null };
}

export function parseSSRCookie(context: any) {
  return SSRCookie.parse(context.req.headers.cookie ?? "");
}

export function hasAccess(
  _allowedRoles: string[],
  _userPermissions: string[] | undefined | null
) {
  if (_userPermissions) {
    return Boolean(
      _allowedRoles?.find((aRole) => _userPermissions.includes(aRole))
    );
  }
  return false;
}
export function isAuthenticated(_cookies: any) {
  return (
    !!_cookies[TOKEN] &&
    Array.isArray(_cookies[PERMISSIONS]) &&
    !!_cookies[PERMISSIONS].length
  );
}
